import type { StaticImageData } from 'next/image';

export type OtaInfo = {
  url: string | undefined;
  name: string;
  icon: StaticImageData;
};

export type OtaInfoMap = {
  [key: string]: OtaInfo;
};

/**
 * Represents a successful quote comparison from an external source (like Airbnb or VRBO)
 */
export interface SuccessfulComparisonQuote {
  checkInDate: string;
  checkOutDate: string;
  externalListingId: string;
  externalSource: string;
  numberOfAdults: number;
  numberOfChildren: number;
  numberOfInfants: number;
  numberOfPets: number;
  priceCents: number;
}

/**
 * Represents a comparison where the listing wasn't found on the platform
 */
export interface MissingComparisonQuote {
  externalSource: string;
}

/**
 * Union type that can be used throughout the application
 */
export type ComparisonQuoteResult =
  | SuccessfulComparisonQuote
  | MissingComparisonQuote;

/**
 * Type guard to check if a comparison quote has price information
 */
export function isSuccessfulComparisonQuote(
  quote: ComparisonQuoteResult
): quote is SuccessfulComparisonQuote {
  return (
    '__typename' in quote &&
    quote.__typename === 'ComparisonQuote' &&
    'priceCents' in quote
  );
}
